<template>
    <MenuComponent />
    <Dialog modal v-model:visible="modal" :closable="false">
        <div class="cont-80 mr-auto">
            <br>
            <p class="c-warning text-center">ADVETENCIA</p>
            <br>
            <p>Lo sentimos pero la informacion de este cliente no es correcta, por favor contacta a sistemas para ver
                mas detalles</p><br>
            <Button label="Continuar" class="cont-100 mr-auto d-block" severity="contrast" @click="Regresar" />
        </div>
    </Dialog>

    <div>
        <div class="wrap">
            <div class="cont-100 d-flex">
                <Button icon="pi pi-arrow-left" severity="secondary" @click="Regresar" />
                <div class="sup-2 mr-l-2">
                    <h1>{{ cliente.NOMBRE }} <span class="activeclient">cliente activo</span></h1>
                    <p>ID ORG-{{ cliente.consec }}</p>
                </div>

            </div>
            <br><br>
            <div class="d-flex cont-100">
                <div class="contenido1">
                    <div class="card">
                        <div class="mr-auto cont-90">
                            <br>
                            <div class="d-flex-f text-18">
                                <div class="cont-100">
                                    <p class="tw-bold">Informacion del usuario</p>
                                </div>
                                <div class="cont-5">
                                    <li class="pi pi-shield text-right"></li>
                                </div>
                            </div>
                            <br><br>
                            <p class="text-12 silver tw-bold">NOMBRE DE ORGANIZACION</p>
                            <p class="text-16 ">{{ cliente.Nombre_U }}</p>
                            <br>
                            <div class="cont-100 d-flex">
                                <div class="cont-50">
                                    <p class="text-12 silver tw-bold">RFC (TAX ID)</p>
                                    <p class="text-16 " v-if="cliente.RFC === 'XEXX010101000'">{{ cliente.TAXId }}</p>
                                    <p class="text-16 ">{{ cliente.RFC }}</p>
                                </div>
                                <div class="cont-50">
                                    <p class="text-12 silver tw-bold">SECTOR</p>
                                    <p class="text-16 ">{{ cliente.Sector }}</p>
                                </div>
                            </div>
                            <br>
                            <p class="text-12 silver tw-bold">RAZON SOCIAL</p>
                            <p class="text-16 ">{{ cliente.NOMBRE }}</p>
                            <br>
                            <p class="text-12 silver tw-bold">DIRECCION</p>
                            <p class="text-16 ">{{ cliente.CALLE }} {{ cliente.NUMEXT }},
                                {{ cliente.COLONIA }} {{ cliente.LOCALIDAD }},
                                {{ cliente.ESTADO }}, {{ cliente.PAIS }}, CP: {{ cliente.CODIGO }}</p>
                        </div>
                    </div>
                    <br>
                    <div class="card">
                        <div class="cont-90 mr-auto">
                            <br>
                            <p class="text-18 silver tw-bold">ESTADISTICAS</p>
                            <br>
                            <div class="cont-90 d-flex-f">
                                <div class="stad">
                                    <p class="cant">{{ totalCotizaciones }}</p>
                                    <p class="title">COTIZACIONES</p>
                                </div>
                                <div class="stad mr-l-2">
                                    <p class="cant">1</p>
                                    <p class="title">CONTACTO</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contenido2">
                    <div class="card">
                        <div class="cont-90 mr-auto">
                            <br>
                            <p class="text-18 silver tw-bold">CONTACTOS</p>
                            <p class="text-12">da clic al correo para contactarlos</p><br>
                            <hr>
                            <br>
                            <div class="cont-100 d-flex-f">
                                <div class="cont-50">
                                    <p class="text-12 silver tw-bold">NOMBRE</p>
                                </div>
                                <div class="cont-50">
                                    <p class="text-12 silver tw-bold">CORREO</p>
                                </div>
                            </div>
                            <div class="cont-100 d-flex-f mr-t-4">
                                <div class="cont-50">
                                    <p class="text-10 ">{{ cliente.contacto }}</p>
                                </div>
                                <div class="cont-50">
                                    <a :href="`mailto:${cliente.Email}`" class="text-d contrast">
                                        <p class="text-10">{{ cliente.Email }}</p>
                                    </a>
                                </div>
                            </div>
                            
                        </div>
                        <br><br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Button, Dialog } from 'primevue';
import { onMounted, ref } from 'vue';
import MenuComponent from '../MenuComponent.vue';
import api from '@/plugins/Axios';
import { useRoute, useRouter } from 'vue-router';

const modal = ref(false);
const route = useRoute();
const cliente = ref([]);
const router = useRouter();
const totalCotizaciones = ref(0);

const obtenerCotizaciones = async () => {
    try {
        let form = new FormData();
        form.append("id", route.params.id)
        form.append("cotizaciones_cliente", "");
        form.append("token", localStorage.getItem("token"));
        const res = await api.post("/Api_Usuario", form);
        console.log(res.data)
        totalCotizaciones.value = res.data.message.length;
    }
    catch (err) {
        console.error(err);
    }
}

const obtenerCliente = async () => {
    try {
        let form = new FormData();
        form.append("id", route.params.id)
        form.append("get_cliente_FXT", "");
        form.append("token", localStorage.getItem("token"));
        const res = await api.post("/Api_Usuario", form);
        if (res.data.length === 0) {
            modal.value = true;
        }
        else {
            cliente.value = res.data[0];
            console.log(res.data)
        }
    }
    catch (err) {
        console.error(err);
    }
}

const Regresar = () => {
    router.push("/clientes");
}

onMounted(() => {
    obtenerCliente();
    obtenerCotizaciones();
})
</script>

<style scoped>
.silver {
    color: gray;
}

.activeclient {
    padding: 2px;
    background: rgb(168, 215, 168);
    color: rgb(2, 86, 2);
    font-size: 10px;
    border-radius: 20px;
}

.contenido1 {
    width: 65%;
    margin: auto;

}

.stad {
    width: 60%;
    background: silver;

    border-radius: 12px;
    font-weight: bold;
    text-align: center;
    padding: 10px;

}

.stad .title {
    font-size: 16px;
}

.stad .cant {
    color: rgb(69, 89, 127);
    font-size: 50px;
}

.contenido2 {
    width: 33%;
    margin-left: auto;
}

.card {
    background: white;
    border-radius: 10px;
    box-shadow: 0px 4px 5px silver;
    padding: 5px;
}

@media (prefers-color-scheme: dark) {
    .card {
        background: black;
        box-shadow: 0px 4px 5px black;
        transition: all .45s;
    }

    .stad {
        width: 50%;
        background: rgb(27, 27, 27);
    }
}
</style>